export default __webpack_public_path__ + "static/media/ceramol-iage-result-keep-bright.86e86081.png";